{
	"termsAndConditions": {
		"title": "Allmänna villkor",
		"submitTitle": "Acceptera och fortsätt till Integritetspolicy"
	},
	"privacyPolicy": {
		"title": "Integritetspolicy",
		"submitTitle": "Acceptera och stäng",
		"backTitle": "Tillbaka"
	}
}
